import React from 'react';

const ContactModal = ({show, message}) => (
  <div id="contactModal" className={`contactFormModalContainer ${show? 'contactFormModalShow': ""}`}>
    <p>{message.line1}</p>
    <p>{message.line2}</p>
  </div>
)

export default ContactModal;